import { render, staticRenderFns } from "./detailManag.vue?vue&type=template&id=34473146&scoped=true"
import script from "./detailManag.vue?vue&type=script&lang=js"
export * from "./detailManag.vue?vue&type=script&lang=js"
import style0 from "./detailManag.vue?vue&type=style&index=0&id=34473146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34473146",
  null
  
)

export default component.exports